import { DefaultService } from '@/services/DefaultService';

export default class CrmAgendaService extends DefaultService {
    findAll(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/crm/agenda-evento.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    find(uuid) {
        return this._http
            .get(`${this._env}/crm/agenda-evento/uuid/${uuid}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(evento, recorrencia = false) {
        return this._http
            .post(
                `${this._env}/crm/agenda-evento/update-situacao/${recorrencia}`,
                evento,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacaoAssUser(evento, recorrencia = false) {
        return this._http
            .post(
                `${this._env}/crm/ass-agenda-evento-usuario/update-situacao/${recorrencia}`,
                evento,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    save(form) {
        return this._http
            .post(
                `${this._env}/crm/agenda-evento/${form.uuid == null ? 'insert' : 'update'}`,
                form,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    execute(form) {
        return this._http
            .post(
                `${this._env}/crm/agenda-execucao`,
                form,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
